import "./react.shim"; //检查环境是否有react，进行降级处理，适用于仅vue的环境。
export { default as MainApplication } from './MainApplication';
export { default as SmallApplication } from './SmallApplication';
export { default as ComponentLoader } from './ComponentLoader';
